import { createContext } from "preact";
import { useContext } from "preact/hooks";

const PortalContext = createContext<HTMLElement | null>(null);

export function PortalProvider({
  container,
  children,
}: {
  container: HTMLElement | null;
  children: preact.ComponentChildren;
}) {
  return (
    <PortalContext.Provider value={container}>
      {children}
    </PortalContext.Provider>
  );
}

export function usePortalContainer() {
  return useContext(PortalContext);
}
